import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    modal: css({
        background: theme.palette.common.white,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        padding: '20px',
        width: '50%',
        maxHeight: '90vh',
        maxWidth: '90vw',
        overflowY: 'auto',
        ':focus': {
            outline: 'none',
        },
        [theme.breakpoints.up('lg')]: {
            width: '642px',
            padding: '60px 40px 40px 40px',
            gap: '30px',
        },
    }),

    cta: css({
        marginTop: '30px',
        width: '100%',
        borderRadius: '100px',
        padding: '16px 16px 12px 16px',
        textTransform: 'uppercase',
    }),
};
